/** Minimum height for graph/list area to prevent layout jump when toggling views */
export const MIN_VIEW_HEIGHT = 309;
